<template>
    <div class="password-component">
        <v-text-field
            :label="t.password"
            v-model="password"
            :append-icon="showPassword ? 'none' : 'none'"
            :suffix="showPassword ? commonStrings.hide : commonStrings.show"
            :rules="passwordRules"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            @input="updatedPassword"
            required
        ></v-text-field>
        <ul>
            <li :class="{completed: includes8Chars}">
                <i class="material-icons" v-show="!includes8Chars">clear</i>
                <i class="material-icons" v-show="includes8Chars">check</i>
                <div>{{commonStrings.includes8Chars}}</div>
            </li>
            <li :class="{completed: includesUpper}">
                <i class="material-icons" v-show="!includesUpper">clear</i>
                <i class="material-icons" v-show="includesUpper">check</i>
                <div>{{commonStrings.includesUpper}}</div>
            </li>
            <li :class="{completed: includesLower}">
                <i class="material-icons" v-show="!includesLower">clear</i>
                <i class="material-icons" v-show="includesLower">check</i>
                <div>{{commonStrings.includesLower}}</div>
            </li>
            <li :class="{completed: includesNumber}">
                <i class="material-icons" v-show="!includesNumber">clear</i>
                <i class="material-icons" v-show="includesNumber">check</i>
                <div>{{commonStrings.includesNumber}}</div>
            </li>
            <li :class="{completed: includesSpecialChars}">
                <i class="material-icons" v-show="!includesSpecialChars">clear</i>
                <i class="material-icons" v-show="includesSpecialChars">check</i>
                <div>{{commonStrings.includesSpecialChars}}</div>
            </li>
        </ul>
    </div>
</template>

<script>
import { StringService } from "@nuskin/ns-util";

export default {
  name: "Password",
  data() {
    return {
      includes8Chars: false,
      includesUpper: false,
      includesLower: false,
      includesNumber: false,
      includesSpecialChars: false,
      password: "",
      passwordRules: [],
      passwordError: "",
      showPassword: false,
      t: {},
      commonStrings: []
    };
  },
  methods: {
    updatedPassword() {
      this.$emit("passwordUpdated", this.password);
    },
    loadCommonStrings() {
      let strings = [
        { key: "show", dflt: "show" },
        { key: "hide", dflt: "hide" },
        { key: "includes8Chars", dflt: "Use 8 or more characters" },
        {
          key: "includesUpper",
          dflt: "Use an upper case letter (e.g. A)"
        },
        {
          key: "includesLower",
          dflt: "Use a lower case letter (e.g. a)"
        },
        { key: "includesNumber", dflt: "Use a number (e.g. 1234)" },
        {
          key: "includesSpecialChars",
          dflt: "Use a symbol (e.g. !@#$)"
        },
        {
          key: "passwordConditionsMet",
          dflt:
                        "Password must include 8 characters at least 3 of the other 4 below"
        }
      ];
      StringService.getStrings(strings).then(response => {
        this.commonStrings = response;
      });
    },
    passwordValid() {
      let totalCompleted = 0;
      this.password.match(/(?=.*[A-Z])/)
        ? totalCompleted++
        : (totalCompleted += 0);
      this.password.match(/(?=.*[a-z])/)
        ? totalCompleted++
        : (totalCompleted += 0);
      this.password.match(/(?=.*[0-9])/)
        ? totalCompleted++
        : (totalCompleted += 0);
      this.password.match(/(?=.*[@#$%^&*()_+?~!])/)
        ? totalCompleted++
        : (totalCompleted += 0);
      return totalCompleted > 2;
    }
  },
  mounted() {
    this.t = this.$store.state.translations.t;
    this.loadCommonStrings();
    StringService.getString(
      "passwordRequired",
      "4 of 5 requirements must be met"
    ).then(response => {
      this.passwordError = response;
      this.passwordRules = [
        v => !!v || this.passwordError,
        v =>
          this.passwordValid() ||
                    this.commonStrings.passwordConditionsMet,
        v => (v && v.length > 7) || this.commonStrings.includes8Chars
      ];
    });
  },
  watch: {
    password() {
      this.includes8Chars = this.password.match(/(?=.{8,})/);
      this.includesUpper = this.password.match(/(?=.*[A-Z])/);
      this.includesLower = this.password.match(/(?=.*[a-z])/);
      this.includesNumber = this.password.match(/(?=.*[0-9])/);
      this.includesSpecialChars = this.password.match(
        /(?=.*[@#$%^&*()_+?~!])/
      );
    }
  }
};
</script>

<style lang="scss">
@import "~@nuskin/ns-core-styles/src/scss/colors";

.password-component {
    ul {
        text-align: left;
        list-style: none;
        padding-left: 0;
        line-height: 26px;
        margin-bottom: 20px;
        li {
            display: flex;
            align-items: center;
            i {
                font-size: 15px;
                margin-right: 5px;
            }
            &:not(.completed) {
                i {
                    color: map-get($baseColors, eyore);
                }
            }
        }
    }
    .completed {
        color: map-get($baseColors, progress-color);
    }
}
</style>
